import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import Landing from "./components/Landing";
import ForgotPassword from "./components/ForgotPassword";
import PersonalInformation from "./components/PersonalInformation";
import ChangePassword from "./components/ChangePassword";
import Classes from "./components/Classes";
import Sessions from "./components/Sessions";
import Terms from "./components/Terms";
import Sections from "./components/Sections";
import Subjects from "./components/Subjects";
import Students from "./components/Students";
import Teachers from "./components/Teachers";
import Parents from "./components/Parents";
import ClassDetailsPage from './components/ClassDetailsPage';
import Archives from './components/Archives';
import ArchiveSessions from './components/ArchiveSessions';
import ArchiveTerms from './components/ArchiveTerms';
import ArchiveClasses from './components/ArchiveClasses';
import ClassResults from './components/ClassResults';
import SubjectScores from "./components/SubjectScores";
import PsychomotorSkills from "./components/PsychomotorSkills";
import Attendance from "./components/Attendance";
import Timetable from "./components/Timetable";
import Questions from "./components/Questions";
import AttendanceIndividual from "./components/AttendanceIndividual";
import ClassResultsIndividual from "./components/ClassResultsIndividual";
import { DashboardProvider } from "./context/DashboardContext";
import { ManagementProvider } from "./context/ManagementContext";
import StudentLogin from "./components/StudentLogin";
import StudentDashboard from "./components/StudentDashboard";
import QuestionsClasses from "./components/QuestionsClasses";
import QuestionsTerms from "./components/QuestionsTerms";
import QuestionsSubjects from "./components/QuestionsSubjects";
import Exam from "./components/Exam";
import PDFViewer from "./components/PDFViewer";
import FeesClasses from "./components/FeesClasses";
import Fees from "./components/Fees";
import Dashboard from "./components/Dashboard";

function App() {
  return (
    <>
      <UserAuthContextProvider>
        <DashboardProvider>
          <ManagementProvider>
            <Routes>              
              <Route
                path="/home"
                element={<ProtectedRoute><Home /></ProtectedRoute>}
              />
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/student-login" element={<StudentLogin />} />
              <Route path="/student-dashboard" element={<StudentDashboard />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/personal-information" element={<ProtectedRoute><PersonalInformation /></ProtectedRoute>} />
              <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/classes" element={<ProtectedRoute><Classes /></ProtectedRoute>} />
              <Route path="/classes/:id" element={<ProtectedRoute><ClassDetailsPage /></ProtectedRoute>} />
              <Route path="/sessions" element={<ProtectedRoute><Sessions/></ProtectedRoute>} />
              <Route path="/terms" element={<ProtectedRoute><Terms/></ProtectedRoute>} />

              <Route path="/sections" element={<ProtectedRoute><Sections/></ProtectedRoute>} />
              <Route path="/subjects" element={<ProtectedRoute><Subjects/></ProtectedRoute>} />
              <Route path="/students" element={<ProtectedRoute><Students/></ProtectedRoute>} />
              <Route path="/teachers" element={<ProtectedRoute><Teachers/></ProtectedRoute>} />
              <Route path="/parents" element={<ProtectedRoute><Parents/></ProtectedRoute>} />
              <Route path="/timetable" element={<ProtectedRoute><Timetable/></ProtectedRoute>} />

              <Route path="/archives" element={<ProtectedRoute><Archives /></ProtectedRoute>} />
              <Route path="/archives/:sectionId" element={<ProtectedRoute><ArchiveSessions /></ProtectedRoute>} />
              <Route path="/archives/:sectionId/:sessionId" element={<ProtectedRoute><ArchiveTerms /></ProtectedRoute>} />
              <Route path="/archives/:sectionId/:sessionId/:termId" element={<ProtectedRoute><ArchiveClasses /></ProtectedRoute>} />
              <Route path="/archives/:sectionId/:sessionId/:termId/:classId" element={<ProtectedRoute><ClassResults /></ProtectedRoute>} />
              <Route path="/results/:sectionId/:sessionId/:termId/:classId/:kidId" element={<ProtectedRoute><ClassResultsIndividual /></ProtectedRoute>} />
              <Route path="/scores/:classId/:subjectId" element={<ProtectedRoute><SubjectScores /></ProtectedRoute>} />
              <Route path="/psychomotor/:classId" element={<ProtectedRoute><PsychomotorSkills /></ProtectedRoute>} />
              <Route path="/attendance/:classId" element={<ProtectedRoute><Attendance /></ProtectedRoute>} />
              <Route path="/attendance/:classId/:kidId" element={<ProtectedRoute><AttendanceIndividual /></ProtectedRoute>} />

              <Route path="/fees-classes" element={<ProtectedRoute><FeesClasses /></ProtectedRoute>} />
              <Route path="/fees/:classId" element={<ProtectedRoute><Fees /></ProtectedRoute>} />

              <Route path="/questions" element={<ProtectedRoute><QuestionsClasses /></ProtectedRoute>} />
              <Route path="/questions/:classId" element={<ProtectedRoute><QuestionsTerms /></ProtectedRoute>} />
              <Route path="/questions/:classId/:termId" element={<ProtectedRoute><QuestionsSubjects /></ProtectedRoute>} />
              <Route path="/questions/:classId/:termId/:subjectId" element={<ProtectedRoute><Questions /></ProtectedRoute>} />
              <Route path="/exam/:subjectId" element={<Exam />} />
              <Route path="/pdf/:pdfLink" element={<PDFViewer />} />
            </Routes>
          </ManagementProvider>
        </DashboardProvider>
      </UserAuthContextProvider>
    </>
  );
}

export default App;